import { createApi } from "@reduxjs/toolkit/query/react";
import { gql } from "graphql-request";
import customBaseQuery from "../../../utils/customBaseQuery";

export const ParticipantSearchAPI = createApi({
  reducerPath: "getParticipantsApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getParticipantsApi: builder.query({
      query: ({
        eventId,
        searchParticipantName,
        searchParticipantEmail,
        pageNo,
        pageCount
      }: any) => ({
        url: "/graphql",
        body: gql`query{
            getEnrolledParticipantWithSearch(
              eventId:"${eventId}",
            searchCriteria:{
              name:"${searchParticipantName}"
              email:"${searchParticipantEmail}"
            },
          sortCriteria: {sortKey: "name", pageNo: ${pageNo}, pageCount: ${pageCount}, order: "ASC"}){
              timestamp
              data{
                activeUsers{
                  id
                  name{
                    fullName
                    lastName
                    firstName
                  }
                  email
                  profileImageUrl
                }
                activeCount
              }
              error
              version
            }
          }`
      })
    })
  })
});

export const { useLazyGetParticipantsApiQuery } = ParticipantSearchAPI;
